import { ApiError } from '@/shared/api/api-client/api-error';
import { API_CREATE_SUPPORT_REQUEST } from '@/shared/constants/bff-endpoints';
import { SupportFormInput } from '@/shared/lib/validation/support/support.schema';


export async function createSupportRequest (data: SupportFormInput): Promise<void> {
    const res = await fetch(API_CREATE_SUPPORT_REQUEST, {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify(data),
    });

    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new ApiError(res.status, errorData);
    }
}
